export const css = {
    root: '_1z1P3J1t',
    titleBlock: '_3n6NtJ-j',
    title: '_773rgEfG',
    eyebrow: '_2aZZ4zvF',
    openCloseIcon: '_2uSmJ8kj',
    close: '_2cQTpPk_',
    topicgroup: '_2tK4UEjs',
    item: 'wAnGVk7O',
    setTitleBlock: 'TB3nupsD',
    emptyTitleBlock: '_1Enr2h2T',
    actionBlock: '_31eKWwso',
    setTitle: 'gArX4Xp_',
    setProgress: '_3uo-KN5G',
    setProficiency: '_3gpYOhzV',
    accordionLegend: '_2s5xYCNL',
    accordionLegendPlaceholder: '_2941Ga2W',
    accordionLegendProgress: '_1I458rXe',
    accordionLegendProficiency: '_28YVI5yh',
    accordionBody: '_3wRFFcp5',
    itemWrapper: '_2LsRWgUQ',
    completed: '_1ccxcRlM',
    shortDesc: 'hk7PmuN8',
    truncate: '_1yHeAuub',
    status: '_2eg3ByEF',
    progressBar: '_3nqd2Jvu',
    whiteIcon: 'G795Ca2t',
    openTitle: '_129x-V2_',
    closedTitle: 'TfVKIsrl',
    statusLine: '_3nMCZIl2',
    ' _key': 'afcpe-theme/afcpe/book-widgets/topicaccordion'
};
export default css;
